import axios from "axios";
import NProgress from "nprogress";
import { baseUrl } from "../app.config";
import store from "../store/store";

const apiClient = axios.create({
  baseURL: baseUrl,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  },
  timeout: 30000
});

apiClient.interceptors.request.use(config => {
  NProgress.start();
  store.dispatch("loader/showBlockingLoader", true, { root: true });
  return config;
});
apiClient.interceptors.response.use(response => {
  NProgress.done();
  store.dispatch("loader/showBlockingLoader", false, { root: true });
  return response;
});

export default {
  getAllOrganizations(payload) {
    return apiClient.post("/getAllOrganizations", JSON.stringify(payload));
  }
};
